<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <div class="lead-time-group">
            <app-input-text #quantity
                        (inputValueChange)="quantityInputChange($event)"
                        [messages]="quantityInputMessages"
                        [validators]="validators.quantity"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-lead-time-modal-quantity"
                        label="Quantity"
                        maxLength="3"
                        placeholder="e.g. 000"></app-input-text>
            <app-input-dropdown #unit
                                [inputFormatter]="typeahead.inputTextNameFormatter"
                                [resultFormatter]="typeahead.inputTextNameFormatter"
                                [resultsFunction]="searchUnit"
                                (inputValueChange)="unitInputChange($event)"
                                [messages]="unitInputMessages"
                                [warningLevel]="WarningsEnum.WARNING_SAVE"
                                baseCypressTag="business-settings-lead-time-modal-time-unit"
                                label="Time unit"
                                placeholder="Please, select a time unit"></app-input-dropdown>
        </div>
        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>
</app-generic-modal>
